export default "__VITE_ASSET__DbcklA4n__"